document.addEventListener('DOMContentLoaded', function() {
    const externalFooterLinks = document.querySelectorAll('.footer-block:has(:is(.Contact, .Heures, .Hours)) a');
    externalFooterLinks.forEach((link) => {
        link.setAttribute('target',"_blank");
    })
    const allMapsLinks = document.querySelectorAll('a[href="https://maps.app.goo.gl/kU7t2EmStqUPmiPQ9"]');
    if (allMapsLinks) {
      allMapsLinks.forEach((link) => {
        link.setAttribute('target',"_blank");
    })
    }

    const pathname = window.location.pathname;
    const pathSegments = pathname.split('/').filter(Boolean);
    const pageSlug = pathSegments[pathSegments.length - 1];

    document.body.classList.add(pageSlug);
    
// Translation function for Klaviyo Back in Stock form
function translateKlaviyoForm() {
    if (window.Shopify && window.Shopify.locale === 'fr') {
      
      // Translate the BIS trigger button
      const translateButton = () => {
        const bisButton = document.querySelector('#klaviyo-bis-button-container button[data-a11y-identifier^="bis-button-"]');
        if (bisButton && bisButton.textContent.includes('NOTIFY ME WHEN AVAILABLE')) {
          bisButton.textContent = 'M\'AVISER LORSQUE DISPONIBLE';
        }
      };
      
      // Translate the form
      const translateForm = () => {
        const form = document.querySelector('form.klaviyo-form[data-testid^="klaviyo-form-"]');
        
        if (form) {
          // Translate heading
          const heading = form.querySelector('h1 span');
          if (heading && heading.textContent.includes('Back In Stock')) {
            heading.textContent = 'Formulaire de retour en stock';
          }
          
          // Translate subheading
          const subheading = form.querySelector('p span');
          if (subheading && subheading.textContent.includes('Be alerted when')) {
            subheading.textContent = 'Soyez alerté lorsque le produit revient.';
          }
          
          // Translate email input
          const emailInput = form.querySelector('input[type="email"][name="email"]');
          if (emailInput && emailInput.placeholder.includes('Email')) {
            emailInput.placeholder = 'Adresse courriel';
          }
          
          // Translate email label (for screen readers)
          const emailLabel = form.querySelector('label[for^="email_"]');
          if (emailLabel && emailLabel.textContent.includes('Email')) {
            emailLabel.textContent = 'Courriel';
          }
          
          // Translate checkbox legend (for screen readers)
          const checkboxLegend = form.querySelector('legend[id*="opt_in_promotional"]');
          if (checkboxLegend && checkboxLegend.textContent.includes('promotional')) {
            checkboxLegend.textContent = 'Cochez cette case pour recevoir également des courriels promotionnels.';
          }
          
          // Translate checkbox label
          const checkboxLabel = form.querySelector('label[for*="opt_in_promotional"] div:last-child');
          if (checkboxLabel && checkboxLabel.textContent.includes('promotional')) {
            checkboxLabel.textContent = 'Cochez cette case pour recevoir également des courriels promotionnels.';
          }
          
          // Translate checkbox aria-label
          const checkboxInput = form.querySelector('input[type="checkbox"][name*="opt_in_promotional"]');
          if (checkboxInput && checkboxInput.getAttribute('aria-label')?.includes('promotional')) {
            checkboxInput.setAttribute('aria-label', 'Cochez cette case pour recevoir également des courriels promotionnels.');
          }
          
          // Translate submit button
          const submitButton = form.querySelector('button[type="button"]:not(.klaviyo-close-form)');
          if (submitButton && submitButton.textContent === 'SUBMIT') {
            submitButton.textContent = 'SOUMETTRE';
          }
          
          // Translate close button
          const closeButton = form.querySelector('button.klaviyo-close-form[aria-label*="Close"]');
          if (closeButton) {
            closeButton.setAttribute('aria-label', 'Fermer la boîte de dialogue');
          }
          
          // Translate close button title
          const closeButtonTitle = form.querySelector('button.klaviyo-close-form title');
          if (closeButtonTitle && closeButtonTitle.textContent.includes('Close')) {
            closeButtonTitle.textContent = 'Fermer la boîte de dialogue';
          }
        }
      };
      
      // Poll for BIS button appearance (checks every 200ms for up to 10 seconds)
      let buttonCheckCount = 0;
      const maxButtonChecks = 50; // 10 seconds
      const buttonCheckInterval = setInterval(() => {
        translateButton();
        buttonCheckCount++;
        
        const bisButton = document.querySelector('#klaviyo-bis-button-container button[data-a11y-identifier^="bis-button-"]');
        if (bisButton || buttonCheckCount >= maxButtonChecks) {
          clearInterval(buttonCheckInterval);
        }
      }, 200);
      
      // Wait for form to appear
      const checkFormExists = setInterval(() => {
        const form = document.querySelector('form.klaviyo-form[data-testid^="klaviyo-form-"]');
        if (form) {
          clearInterval(checkFormExists);
          translateForm();
        }
      }, 100);
      
      // Clear interval after 10 seconds if form never appears
      setTimeout(() => {
        clearInterval(checkFormExists);
      }, 10000);
      
      // Watch for dynamic content changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              // Check if BIS button was added
              if (node.matches('#klaviyo-bis-button-container') || node.querySelector('#klaviyo-bis-button-container')) {
                translateButton();
              }
              // Check if form was added
              if (node.matches('[role="dialog"][aria-label="POPUP Form"]') || 
                  node.querySelector('form.klaviyo-form[data-testid^="klaviyo-form-"]')) {
                translateForm();
              }
            }
          });
        });
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
  
  // Run translation when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateKlaviyoForm);
  } else {
    translateKlaviyoForm();
  }
})